import "./About.css";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import aboutContext from "../../context/about/aboutcontext";
import progressContext from "../../context/loading/progresscontext";
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import Values from '../home/values/Values';
import CtaBand from '../home/ctaband/CtaBand';

function About() {
  const { aboutContent, aboutKeys } = useContext(aboutContext);
  const { setProgress } = useContext(progressContext);

  const {
    more,
    moreHeading,
    number1img,
    number2img,
    number3img,
    number4img,
    number5img,
    number6img,
  } = aboutContent || {};

  useEffect(() => {
    window.scrollTo(0, 0);
    if (setProgress) {
      setProgress(70);
      setTimeout(() => {
        setProgress(100);
      }, 100);
    }
  }, [setProgress]);

  const galleryImages = [number1img, number2img, number3img, number4img, number5img, number6img].filter(Boolean);

  return (
    <main className="about-page">
      <Breadcrumb
        pageName="About Us"
        bgImage="/img/uplaods/rad.jpg"
        path={[
          { label: 'Home', href: '/' },
          { label: 'About Us' }
        ]}
      />

      <section className="band about-hero-section">
        <div className="wrap">
          <div className="about-layout-grid">
            {/* Left Content */}
            <div className="about-content-col">
              <p className="eyebrow">About the centre</p>
              <h1 className="about-main-heading">Welcome to Lakshmi Maternity &amp; Surgical Centre!</h1>
              
              <div className="about-prose">
                <p className="about-lead">
                  <strong>Experience exceptional care at Lakshmi Maternity &amp; Surgical Centre, where your well-being is our top priority.</strong> With over <strong>33 years of cumulative experience</strong>, our highly experienced doctors, including <strong>Dr. Mahesh Rao</strong>, and <strong>Dr. Nishita Rao</strong>, are dedicated to providing the best healthcare services in <strong>women's health, maternity care, and surgical procedures</strong>.
                </p>

                <p>
                  As the <strong>best maternity hospital in Bangalore for normal delivery</strong>, we are proud to have a remarkable track record of <strong>90% normal deliveries</strong>, ensuring a <strong>natural childbirth experience</strong> that is safe and supported every step of the way. Our team of <strong>experienced obstetricians</strong> specializes in providing expert care to help you achieve a <strong>safe delivery</strong>, and our <strong>natural childbirth specialists</strong> ensure that both mother and baby are taken care of throughout the process.
                </p>

                {/* Key Metrics Grid */}
                <div className="about-metrics-bar">
                  <div className="about-metric-card">
                    <span className="a-metric-num">90%</span>
                    <span className="a-metric-lbl">Normal Delivery Rate</span>
                  </div>
                  <div className="about-metric-card">
                    <span className="a-metric-num">1,05,000+</span>
                    <span className="a-metric-lbl">Babies Delivered</span>
                  </div>
                  <div className="about-metric-card">
                    <span className="a-metric-num">33+ Yrs</span>
                    <span className="a-metric-lbl">Cumulative Experience</span>
                  </div>
                  <div className="about-metric-card">
                    <span className="a-metric-num">24/7</span>
                    <span className="a-metric-lbl">Emergency Support</span>
                  </div>
                </div>

                <p>
                  At <strong>Lakshmi Maternity &amp; Surgical Centre</strong>, we understand that mother and baby care is of utmost importance, which is why we offer <strong>24/7 labor and delivery support</strong> and affordable maternity care, ensuring that you feel supported and comfortable during this special time.
                </p>

                <p>
                  Our <strong>state-of-the-art facilities</strong> are equipped with the latest <strong>world-class technology</strong>, providing <strong>accurate diagnoses and effective treatments</strong>. From routine check-ups to more complex procedures, we offer a comprehensive range of services, with a special focus on personalized attention for each patient's needs.
                </p>

                <p>
                  <strong>Lakshmi Maternity &amp; Surgical Centre</strong> is a trusted name in <strong>maternity care in Bangalore</strong>, having delivered over <strong>105,000 healthy babies</strong> since 2011. Founded by <strong>Dr. Leela Rao</strong>, we strive to provide the best care possible with a <strong>feel-like-home atmosphere</strong>.
                </p>

                <p>
                  We are a safe delivery hospital with a warm, welcoming environment, where you and your baby's health are our top priority. <Link to="/appointment" className="about-consult-link">Book your consultation today</Link> and experience exceptional care with a hospital dedicated to making your birth experience as smooth and healthy as possible.
                </p>

                <p>
                  Your health and happiness matter to us, and we are here to support you every step of the way at Lakshmi Maternity &amp; Surgical Centre.
                </p>
              </div>

              <div className="about-cta-row">
                <Link className="btn-solid" to="/appointment">
                  Book an Appointment
                </Link>
                <Link className="btn-ghost" to="/doctors">
                  Meet Our Doctors &rarr;
                </Link>
              </div>
            </div>

            {/* Right Sticky Visual Card */}
            <aside className="about-media-col">
              <div className="about-sticky-box">
                <figure className="about-fig">
                  <img
                    src="/img/about.webp"
                    alt="Lakshmi Maternity and Surgical Centre Team"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/img/uplaods/about.webp";
                    }}
                  />
                </figure>
                <div className="about-fig-card">
                  <div className="a-card-header">
                    <span className="a-card-badge">Established 2011</span>
                    <span className="a-card-rating">★ 4.8 Rating</span>
                  </div>
                  <h3 className="a-card-title">Centre of Excellence</h3>
                  <p className="a-card-sub">
                    Founded by <strong>Dr. Leela Rao</strong> &middot; Led by <strong>Dr. Mahesh Rao</strong> &amp; <strong>Dr. Nishita Rao</strong>
                  </p>
                  <ul className="a-card-checklist">
                    <li>✓ High Normal Delivery Track Record</li>
                    <li>✓ 24/7 Labor &amp; Emergency Facilities</li>
                    <li>✓ In-House Diagnostic Lab &amp; Pharmacy</li>
                  </ul>
                  <div className="a-card-buttons">
                    <Link to="/appointment" className="btn-solid btn-sm">
                      Book Consultation
                    </Link>
                    <a href="tel:08023347276" className="btn-ghost btn-sm">
                      Call 080 2334 7276
                    </a>
                  </div>
                </div>
              </div>
            </aside>
          </div>

          {aboutKeys && aboutKeys.length > 0 && (
            <div className="about-feature-grid">
              {aboutKeys.map((item) => (
                <div className="about-feature-card" key={item.id || item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.description || item.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Values Section */}
      <Values />

      {/* Additional Details & Gallery */}
      <section className="band tint">
        <div className="wrap">
          <div className="about-clinical-split">
            <div className="about-clinical-copy">
              <p className="eyebrow">Clinical Excellence</p>
              <h2 className="h-sec">{moreHeading || "Personalised care at every step."}</h2>
              <p className="body-copy" style={{ marginTop: "20px" }}>
                {more || "At Lakshmi Maternity & Surgical Centre, we are committed to upholding the highest standards of medical ethics and professionalism. We constantly strive to stay at the forefront of medical advancements, embracing innovation and excellence in our services."}
              </p>
              <div style={{ marginTop: '24px' }}>
                <Link to="/appointment" className="btn-solid">
                  Book a Consultation
                </Link>
              </div>
            </div>
            <div className="about-clinical-media">
              <figure className="fig fig-wide">
                <img
                  src="/img/uplaods/mother-loves-her-child.avif"
                  alt="Maternity care and family wellness"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/about.webp";
                  }}
                />
              </figure>
            </div>
          </div>

          {galleryImages.length > 0 && (
            <div className="about-gallery-grid">
              {galleryImages.map((img, idx) => (
                <div className="about-gallery-item" key={idx}>
                  <img
                    src={`/img/uplaods/${img}`}
                    alt={`Centre facility ${idx + 1}`}
                    loading="lazy"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
          )}

          <div className="about-commitments">
            <p>
              At Lakshmi Maternity &amp; Surgical Centre, we are committed to upholding the highest standards of medical ethics and professionalism. We constantly strive to stay at the forefront of medical advancements, embracing innovation and excellence in our services. Our aim is to forge lasting relationships with our patients, built on trust, empathy, and exceptional care.
            </p>
            <p>
              Thank you for considering Lakshmi Maternity &amp; Surgical Centre for your healthcare needs. We look forward to serving you and being a part of your remarkable journey towards motherhood and overall well-being.
            </p>
          </div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}

export default About;
